import { useState } from "react";
import {
  DeleteOutlined,
  LinkOutlined,
  EditOutlined,
  BarChartOutlined,
  MoreOutlined,
  UndoOutlined,
  PlaySquareOutlined,
  AlignLeftOutlined,
  UnlockOutlined,
  LockOutlined
} from "@ant-design/icons";
import { Button , Tooltip} from "antd";
import { useMediaQuery } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { graphQL_shema } from "../page/utils/graphql";
import { useMutation } from "@apollo/client";
import { changeStandByType, buildRecordBody, startEventRecSuccess, stopEventRecSuccess } from "../redux/actions";
import { useDispatch } from "react-redux";
import MenuMore from "./MenuMore";
import axios from "axios";
import { initSocketLive } from "../page/utils/socket";
import { ReactComponent as PlayGreen } from './../assests/playGreen.svg';
import { ReactComponent as StopRed } from './../assests/stopRed.svg';
import { ReactComponent as PlayBlue } from './../assests/playBlue.svg';
import store from "../redux/store";
import Cookies from 'js-cookie'

const UseActionMenu = ({
  handleDelete,
  record,
  showModaltabletoaction,
  takeIdVideoTabletoaction,
  handleRestore,
  openModalFlux,
  sendRecordIndex,
  modalContent
}) => {
  const history = useHistory();
  const { event_module } = useSelector(
    (state) => state.ReducerUserData.modules
  );
      const indexationActive  = useSelector((state) => state.reducer.indexationEvents);
  
  const dispatch = useDispatch();

  const { t } = useTranslation(); // translation
  const [startRecordOnDns] = useMutation(graphQL_shema().START_RECORD_ON_DNS, {
    onCompleted: (data) => {
      if (data?.startRecordOnDns?.code === "200") {
        dispatch(startEventRecSuccess(record));
      }
    },
  });
  const [startEvent] = useMutation(graphQL_shema().START_EVENT, {
    onCompleted: (data) => {
      if (data.updateEventOrganizerStatus.code ==="200"){
        if (record.vodRecord) {
          startRecordOnDns({
            variables: {
              isDvr: !!record.isDvr,
              streamName: record.conferenceKey,
              body: buildRecordBody(record),
            },
          });
        }
        handleSocketStart(record.id);

      }
    },
  });
  const searchParams = new URLSearchParams(window.location.search);
  const evenement = searchParams.get("filter"); // language params
  const [stopRecordOnDns] = useMutation(graphQL_shema().STOP_RECORD_ON_DNS, {
    onCompleted: (data) => {
      if (data?.stopRecordOnDns?.code === "200") {
        dispatch(stopEventRecSuccess(record));
      }
    },
  });
  const [endEvent] = useMutation(graphQL_shema().START_EVENT, {
    onCompleted: (data) => {
      if (data.updateEventOrganizerStatus.code ==="200"){
        stopRecordOnDns({
          variables: {
            streamName: record.conferenceKey,
            isDvr: !!record.isDvr,
            isAuto: !!record.isAuto,
          },
        });
        handleSocketEnd(record.id);


      }
    },
  });
  const [ChangeStandByMode] = useMutation(graphQL_shema().Set_Event_Standby_Mode, {
    onCompleted: (data) => {
      if (data.setEventStandbyMode.code==="200"){
        dispatch(changeStandByType(record))
      }

    },
  });
  const handleStandByMode = () =>{
    ChangeStandByMode({
      variables: {
        eventID: record.id,
        standbyMode: !record.isStandby,
      }
    })
  }
  const handleDiffusion = () => {
    switch (record.status) {
      case -1:
        startEvent({
          variables: {
            id: record.id,
            status: 0,
          },
        });
        break;
      case 0:
        endEvent({
          variables: {
            id: record.id,
            status: 1,
          },
        });
        break;

      default:
        startEvent({
          variables: {
            id: record.id,
            status: 0,
          },
        });
        break;
    }
  };
  const handleSocketStart = async (eventId) => {
    try {
      // await initEventCreationSocket(eventId, 0) 
      await initSocketLive(eventId,0,null,store);
  } catch (error) {
      console.error("Failed to start the socket:", error);
  }
  };

  const handleSocketEnd = async (eventId) => {
    try {
      // await initEventCreationSocket(eventId, 1)
      await initSocketLive(eventId,1,null,store);
    } catch (error) {
      console.error("Failed to start the socket:", error);
  }
  };


  const handleOpenFlux = async () => {
    const token = Cookies.get('authToken');
    const url = `https:${window.process.env.API_PLAYER}/api/video/video/crypt-url`
    const params = {
      v: record.conferenceKey,
      y: 'bo',
    };
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    let response;

    try {
      response = await axios.get(url, { params, headers });
    } catch (error) {
      console.error('Erreur lors de la requête :', error);
    }

    if (response) {
      const iframe = (
        <iframe title="player_flux" src={response.data.cryptedURL} className="flow-iframe" width="100%" height="100%" style={{aspectRatio: "16/9"}}
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen
                webkitallowfullscreen="" mozallowfullscreen frameBorder="0"></iframe>
      )
      modalContent(iframe)
      openModalFlux(true)
    }
    
  }
  const handleOpenIndex = async (record) => {

    const token = localStorage.getItem('token');
    const url = `https:${window.process.env.API_PLAYER}/api/video/video/crypt-url`
    const params = {
      v: record.conferenceKey,
      y: 'bo',
    };
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    let response;

    try {
      response = await axios.get(url, { params, headers });
    } catch (error) {
      console.error('Erreur lors de la requête :', error);
    }

    if (response) {
      const rawUrl = response.data.cryptedURL;
      const fullUrl = rawUrl.startsWith("//") ? window.location.protocol + rawUrl : rawUrl;
      const url = new URL(fullUrl);
      url.searchParams.set("indexing", "1");
      
      const iframe = (
        <iframe title="player_index" src={url.toString()} className="flow-iframe" width="100%" height="100%" style={{aspectRatio: "16/9"}}
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen
                webkitallowfullscreen="" mozallowfullscreen frameBorder="0"></iframe>
      )
      
      modalContent(iframe)
      history.push(`/events/indexation/${record.conferenceKey}`,{modalContent:url.toString(),event:record});
     sendRecordIndex(record)

    }
    
  }

  const handleMenuClick = () => {
    history.push(`/events/editevent/${record.id}`, {
      record: record,
      action: "update",
    });

    window.parent.postMessage(
      {
        info: "event_edit",
        value: "edit",
      },
      "*"
    );
  };
  // fonction pour afficher le modal d'embed code
  const handleCode = () => {
    showModaltabletoaction(true, record);
    takeIdVideoTabletoaction(record.idVideo);
  };
  // statistic Route
  const handleStatistic = () => {
    window.parent.postMessage(
      {
        info: "showEventStat",
        value: record.id,
      },
      "*"
    );
  };
 
  
  const indexationMenuAction = (
    <div className={"MenuAction"}>

      {event_module?.event_indexation_action?.authorized && (
      <Tooltip
      title={      t("Tooltip.indexer")}>
             <Button
            key="index"
            has-permission="event_indexation_action"
            onClick={()=>handleOpenIndex(record)}
          icon={<AlignLeftOutlined />}
        />
  
          <span className="EditAction">{t("Action.indexEvent")}</span>
        </Tooltip>
      )}
        
   

      {event_module?.event_get_export_action?.authorized ? (
        <Tooltip
        title={      t("Tooltip.liens")}>
               <Button
            key="edit"
            has-permission="event_get_export"
            onClick={() => handleCode(record)}
          icon={<LinkOutlined />}
        />

          <span className="LinkAction">{t("Action.lienExport")}</span>
        </Tooltip>
      ) : null}



    </div>
  );
  const defaultMenuAction = (
    <div className={"MenuAction"}>

  <Tooltip
          title={
            record.status === 0 ? t("Tooltip.statutEnCours") : record.status === 1 ? t("Tooltip.statutArrete") : t("Tooltip.statutNonDemarre")
          
          }>
        <Button
          key="diffusion"
          onClick={handleDiffusion}
          disabled={record.status===1}
          style={{
            color:
              record.status === 0 ? "green" : record.status === 1 ? "red" : "",
          }}

          icon={
            record.status === 0 ? (
              <PlayGreen />
            ) : record.status === 1 ? (
              <StopRed />
            ) : (
              <PlayBlue />
            )
          }
        />

        <span className="EditAction">{t("Action.diffuser")}</span>
      </Tooltip>

      {event_module?.event_flux_live_no_api?.authorized && (
      <Tooltip
      title={      t("Tooltip.preview")}>
             <Button
            key="flux"
            has-permission="event_flux_live_no_api"
            onClick={handleOpenFlux}
          icon={<PlaySquareOutlined />}
        />
  
          <span className="EditAction">{t("Action.flux")}</span>
        </Tooltip>
      )}
       {(event_module?.event_standby_no_api_action?.authorized && record.isAuto) && (
   <Tooltip
   title={
     !record.isStandby
       ? t("Tooltip.modePublicActif")
       : t("Tooltip.modePriveActif")
   }
>
      <Button
     key="locked_event"
     has-permission="event_standby_no_api_action"
     style={{
       background:
         record.isStandby  ? "#ff1a1acc" : "#17a617",
         color:"white"
     }}
     onClick={handleStandByMode}

   icon={record.isStandby?<LockOutlined />:<UnlockOutlined />}
 />

 </Tooltip>

       )

       } 
   

      {event_module?.event_post_edit_action?.authorized && (
        <Tooltip
        title={      t("Tooltip.modifier")}>
             <Button
            key="edit"
            has-permission="event_post_edit"
            onClick={handleMenuClick}
          icon={<EditOutlined />}
        />
  
          <span className="EditAction">{t("Action.modifier")}</span>
        </Tooltip>
      )}
      {event_module?.event_get_export_action?.authorized ? (
        <Tooltip
        title={      t("Tooltip.liens")}>
               <Button
            key="edit"
            has-permission="event_get_export"
            onClick={() => handleCode(record)}
          icon={<LinkOutlined />}
        />

          <span className="LinkAction">{t("Action.lienExport")}</span>
        </Tooltip>
      ) : null}

      {event_module?.event_delete_event_live_action?.authorized ? (
        <Tooltip
        title={    evenement === "trash"?  t("Tooltip.supprimerDefinitivement"): t("Tooltip.supprimer")}>
                  <Button
            has-permission="event_delete_event_live"
            onClick={() => handleDelete(record)}
          icon={<DeleteOutlined />}
        />
          <span className="DeleteAction">{t("Action.Supprimer")}</span>
        </Tooltip>
      ) : null}

       {event_module && evenement === "trash" ? (
        <Tooltip
        title={      t("Tooltip.restaurer")}>
                  <Button
            has-permission="event_delete_event_live"
            onClick={() => handleRestore(record)}
          icon={<UndoOutlined />}
        />
          <span className="DeleteAction">{t("Action.Supprimer")}</span>
        </Tooltip>
      ) : null}
      {event_module?.event_stats_no_api_action?.authorized ? (
        <Tooltip
        title={      t("Tooltip.statistiques")}>
                <Button
            has-permission="event_stats_no_api"
            onClick={handleStatistic}
          icon={<BarChartOutlined />}
        />
   
          <span className="StatisticAction">{t("Action.Statistiques")}</span>
        </Tooltip>
      ) : null}
    </div>
  );
  let menuAction = indexationActive? indexationMenuAction: defaultMenuAction
  const size = useMediaQuery("(max-width: 600px)");
  const [anchor, setAnchor] = useState(null);
  const open = Boolean(anchor);
  const handleOpen = (e) => {
		setAnchor(e.target);
	};
	const handleClose = () => setAnchor(null);

  return (
    <>
      <div className="div_tooltip_action" id="content-desktop">

        {size ? 
          <>
          <Button
          className="moreIcon"
          onClick={handleOpen}
          icon={<MoreOutlined />}/>
          <MenuMore anchor={anchor} open={open} close={handleClose} menu={menuAction}/>
          </> 
          :  
          menuAction
         }
      </div>
    </>
  );
};

export default UseActionMenu;
